import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import UserService from "@/services/api/UserService";
import RegisterStepPhone from "./Step/RegisterStepPhone";
import RegisterStepOtp from "./Step/RegisterStepOtp";
import RegisterStepForm from "./Step/RegisterStepForm";
import { loginAfterAuthSuccess } from "@/helpers/auth";
import { useDispatch } from "react-redux";
import { usePathname, useRouter } from "next/navigation";

const RegisterForm = ({ setDrawerType, setDrawerOpen }) => {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [timeLeft, setTimeLeft] = useState(120);
  const router = useRouter();
  const pathName = usePathname();
  console.log("pathName", pathName);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (step !== 2 || timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft, step]);

  const handleSendOtp = async ({ phone }) => {
    setLoading(true);

    try {
      await UserService.sendRegOtp({ phone_number: phone });
      setPhone(phone);
      setOtp("");
      toast.success("ওটিপি পাঠানো হয়েছে");
      setTimeLeft(120);
      setStep(2);
    } catch (err) {
      const serverMsg = err?.response?.data?.message;
      console.log("serverMsg", serverMsg);

      if (
        serverMsg ==
        "এই নাম্বার দিয়ে ইতিমধ্যেই একটি অ্যাকাউন্ট রয়েছে। দয়া করে লগইন করুন।"
      ) {
        // ইউজার আগে থেকেই আছে
        toast.error(
          "এই নাম্বার দিয়ে ইতিমধ্যেই একটি অ্যাকাউন্ট রয়েছে। দয়া করে লগইন করুন।"
        );
      } else {
        toast.error("ওটিপি পাঠাতে ব্যর্থ হয়েছে");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      await UserService.sendOtp({ phone_number: phone });
      toast.success("ওটিপি আবার পাঠানো হয়েছে");
      setTimeLeft(120);
      setOtp("");
    } catch {
      toast.error("ওটিপি পাঠাতে ব্যর্থ হয়েছে");
    }
  };

  const handleVerifyOtp = async () => {
    try {
      await UserService.verifyOtp({ phone_number: phone, otp_code: otp });
      toast.success("ওটিপি যাচাই সফল হয়েছে");
      setStep(3);
    } catch {
      toast.error("ওটিপি যাচাই ব্যর্থ হয়েছে");
    }
  };

  const handleRegister = async (values) => {
    try {
      const payload = { ...values, phone };
      await UserService.register(payload);
      toast.success("রেজিস্ট্রেশন সফল হয়েছে", {
        position: "top-center",
        autoClose: 1000, // 1 second
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        hideProgressBar: false,
      });
      await loginAfterAuthSuccess(
        payload,
        dispatch,
        toast,
        setDrawerOpen,
        router,
        "",
        pathName
      );
    } catch (error) {
      console.log("error", error);
      toast.error("রেজিস্ট্রেশন বা লগইন ব্যর্থ হয়েছে");
    }
  };

  return (
    <>
      {step === 1 && (
        <RegisterStepPhone onSubmit={handleSendOtp} loading={loading} />
      )}
      {step === 2 && (
        <RegisterStepOtp
          otp={otp}
          setOtp={setOtp}
          timeLeft={timeLeft}
          onResend={handleResendOtp}
          onVerify={handleVerifyOtp}
          onEditPhone={() => setStep(1)}
        />
      )}
      {step === 3 && (
        <RegisterStepForm onSubmit={handleRegister} pathName={pathName} />
      )}
    </>
  );
};

export default RegisterForm;
